import { Response } from '../interfaces/';
import { map, Observable, OperatorFunction } from 'rxjs';

/**
 * Extrae los datos de una respuesta exitosa. Lanza error si el estado no es 'success'.
 */
export function extractSuccessData<T>(response: Response<T>): T {
  if (response.status === 'success' && response.data !== undefined) {
    return response.data;
  }
  throw new Error(`Response is not successful. Status: ${response.status}`);
}

/**
 * Devuelve null si no es success, útil para componentes tolerantes a estado incompleto.
 */
export function extractDataOrNull<T>(response: Response<T>): T | null {
  return response.status === 'success' ? response.data ?? null : null;
}

export function extractData<T>() {
  return (source$: Observable<Response<T>>): Observable<T | undefined> => {
    return source$.pipe(map((res) => (res.status === 'success' ? res.data : undefined)));
  };
}

export function extractStatusSuccess(): OperatorFunction<Response<unknown>, boolean> {
  return map((response) => {
    if (response.status === 'success') return true;
    throw new Error(`Operation failed. Status: ${response.status}`);
  });
}
